import {
  InputGroup,
  Legend,
  ValidationMessage,
} from "@gjensidige/builders-components";
import React, { FocusEventHandler, FunctionComponent, ReactNode } from "react";

interface Props {
  id: string;
  labelText?: string;
  value?: string | number | readonly string[] | undefined;
  invalid?: boolean;
  onChange?: (values: string[]) => void;
  onBlur?: FocusEventHandler | undefined;
  errorText?: ReactNode;
  options?: { label: string; value: string }[];
  type?: "radio" | "checkbox";
  variant?: "row" | "row-background" | "column" | "column-background";
}

const FormInputGroup: FunctionComponent<Props> = ({
  options,
  labelText,
  variant = "column",
  invalid,
  onChange,
  value,
  onBlur,
  errorText,
  id,
  type,
}) => {
  return (
    <InputGroup
      variant={variant}
      id={id}
      name={id}
      onChange={onChange}
      type={type}
      value={value}
      onBlur={onBlur}
      invalid={invalid}
    >
      {labelText && <Legend>{labelText}</Legend>}
      {options?.map(({ label, value }) => (
        <InputGroup.Input label={label} value={value} />
      ))}
      <ValidationMessage htmlFor={id} hidden={!invalid} invalid={invalid}>
        {errorText}
      </ValidationMessage>
    </InputGroup>
  );
};

export default FormInputGroup;
